import { isArray } from "underscore";
import ProductRepository from "../../repository/ProductRepository";

class quoteDetailAPICallResponseMaker {
    data = {};
    data_to_send = {};

    constructor(data) {
        this.data_to_send = this.defaultValue();
        this.data = data;
    }

    static statusList = {
        A: { id: "A", text: "Approved", slug: 'Approved' },
        P: { id: "P", text: "Pending", slug: 'Pending' },
        B: { id: "B", text: "No Bid", slug: 'NoBid' },
        R: { id: "R", text: "Booked", slug: 'Booking' },
        E: { id: "E", text: "Expired", slug: 'Expired' }
    };

    defaultValue = () => {
        return {
            cart_quote_active_session: {},
            quoteNumber: "",
            quoteRequestedDate: "",
            quoteExpirationDate: "",
            contactName: "",
            contactEmail: "",
            contactPhone: "",
            quoteRevisionNumber: "",
            quoteReferenceNumber: "",
            displayQuoteNumber: "",
            quoteReasonType: "",
            quoteStatus: null,
            accountNo: "",
            salesOrg: "",
            endCustomerName: "",
            line_items_axios_fetch_slug: false,
            line_items: {
                Approved: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList.A.id,
                    slug: 'Approved'
                },
                Pending: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList.P.id,
                    slug: 'Pending'
                },
                NoBid: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList.B.id,
                    slug: 'NoBid'
                },
                Booking: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList.R.id,
                    slug: 'Booking'
                },
                Expired: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList.E.id,
                    slug: 'Expired'
                }
            },
            quote_approved_list: []
        };
    };



    process = async (axios_params = {}) => {
        if (this.data) {
            if (this.data.quoteNumber !== undefined) {
                this.data_to_send.quoteNumber = this.data.quoteNumber;
            }
            if (this.data.quoteRevisionNumber !== undefined) {
                this.data_to_send.quoteRevisionNumber = this.data.quoteRevisionNumber;
            }
            if (this.data.quoteRequestedDate !== undefined) {
                this.data_to_send.quoteRequestedDate = this.data.quoteRequestedDate;
            }
            if (this.data.quoteReferenceNumber !== undefined) {
                this.data_to_send.quoteReferenceNumber = this.data.quoteReferenceNumber;
            }
            if (this.data.displayQuoteNumber !== undefined) {
                this.data_to_send.displayQuoteNumber = this.data.displayQuoteNumber;
            }
            if (this.data.quoteReasonType !== undefined) {
                this.data_to_send.quoteReasonType = this.data.quoteReasonType;
            }
            if (this.data.quoteStatus !== undefined) {
                this.data_to_send.quoteStatus = this.data.quoteStatus;
            }
            if (this.data.accountNo !== undefined) {
                this.data_to_send.accountNo = this.data.accountNo;
            }
            if (this.data.salesOrg !== undefined) {
                this.data_to_send.salesOrg = this.data.salesOrg;
            }
            if (this.data.endCustomerName !== undefined) {
                this.data_to_send.endCustomerName = this.data.endCustomerName;
            }
            if (this.data.quoteExpirationDate !== undefined) {
                this.data_to_send.quoteExpirationDate = this.data.quoteExpirationDate;
            }
            if (this.data.contactName !== undefined) {
                this.data_to_send.contactName = this.data.contactName;
            }
            if (this.data.contactEmail !== undefined) {
                this.data_to_send.contactEmail = this.data.contactEmail;
            }
            if (this.data.contactPhone !== undefined) {
                this.data_to_send.contactPhone = this.data.contactPhone;
            }

            if (this.data.totalApproved !== undefined) {
                this.data_to_send.line_items.Approved.count = this.data.totalApproved;
            } else if (this.data?.totalOtherQuotesCount?.totalApproved) {
                this.data_to_send.line_items.Approved.count = this.data?.totalOtherQuotesCount?.totalApproved;
            }

            if (this.data.totalPending !== undefined) {
                this.data_to_send.line_items.Pending.count = this.data.totalPending;
            }

            if (this.data.totalNoBid !== undefined) {
                this.data_to_send.line_items.NoBid.count = this.data.totalNoBid;
            } else if (this.data?.totalOtherQuotesCount?.totalNoBid) {
                this.data_to_send.line_items.NoBid.count = this.data.totalOtherQuotesCount.totalNoBid;
            }

            if (this.data.totalBooked !== undefined) {
                this.data_to_send.line_items.Booking.count = this.data.totalBooked;
            } else if (this.data?.totalOtherQuotesCount?.totalBooked) {
                this.data_to_send.line_items.Booking.count = this.data.totalOtherQuotesCount.totalBooked;
            }

            if (this.data.totalExpired !== undefined) {
                this.data_to_send.line_items.Expired.count = this.data.totalExpired;
            } else if (this.data?.totalOtherQuotesCount?.totalExpired) {
                this.data_to_send.line_items.Expired.count = this.data.totalOtherQuotesCount.totalExpired;
            }

            if (axios_params.quoteStatus !== undefined &&
                this.data.quoteLineItems !== undefined && isArray(this.data.quoteLineItems) && this.data.quoteLineItems.length > 0) {
                let slug;
                if (axios_params.quoteStatus &&
                    quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus] !== undefined) {
                    slug = quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus].slug;
                }
                if (slug) {
                    let quoteLineItems = {};
                    this.data.quoteLineItems.map((v) => {
                        let quoteLineItemsHere = v;
                        let quotePriceDetails = {};
                        if (v.quotePriceDetails !== undefined && isArray(v.quotePriceDetails) && v.quotePriceDetails.length > 0) {
                            v.quotePriceDetails.map((vMain, vInner) => {
                                Object.entries(vMain).map((vMainValue, vMainIndex) => {
                                    quotePriceDetails[vMainValue[0] + '_' + vInner] = vMainValue[1];
                                    // For identify the quantity
                                    quotePriceDetails[vMainValue[0] + '_quantity_' + (vInner + 1)] = vMainValue[1];
                                    // quantity_${v[1].quantity_field_selected}`] * v[1][`quotedPrice_${v[1].quantity_field_selected
                                })
                                // quotePriceDetails[`subTotal__quantity_${vInner + 1}`] = price * quantity;
                            });
                        }
                        delete quoteLineItemsHere.quotePriceDetails;
                        quoteLineItemsHere.ERPPartNumber = quoteLineItemsHere.partNumber;
                        // quoteLineItemsHere.uniqueLineItem = quoteLineItemsHere.quoteLineNumber;
                        quoteLineItemsHere.uniqueLineItem = quoteLineItemsHere.customerLineNumber; // quoteLineNumber getting "0000" from API (no any unique value for the quote detail)
                        quoteLineItemsHere.status = slug;
                        quoteLineItemsHere.quoteNumber = this.data.quoteNumber;
                        quoteLineItemsHere.provisionalQuoteNumber = this.data.quoteProvisionalNumber;
                        quoteLineItemsHere.ERPMFRPartNumber = quoteLineItemsHere.erpManufacturerPartNumber;
                        quoteLineItems[quoteLineItemsHere.uniqueLineItem] = { ...quoteLineItemsHere, ...quotePriceDetails };
                    });

                    // quoteLineItems = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(quoteLineItems, true, true, false);
                    quoteLineItems = await new ProductRepository().getProductInventoryPriceWithCpn(quoteLineItems, true, false);
                    

                    Object.entries(quoteLineItems).map((vMain, vInner) => {
                        // const minQty = vMain[1].product.Min;
                        // const multQty = vMain[1].product.Mult;
                        vMain[1].isValid_quantity_1 = true;
                        vMain[1].isValid_quantity_2 = true;
                        vMain[1].isValid_quantity_3 = true;
                        vMain[1].scheduleDetails = [];

                        // if (minQty && multQty) {
                        //     vMain[1].isValid_quantity_1 = this.validateQtyMinMult(vMain[1].quantity_quantity_1, minQty, multQty);
                        //     vMain[1].isValid_quantity_2 = this.validateQtyMinMult(vMain[1].quantity_quantity_2, minQty, multQty);
                        //     vMain[1].isValid_quantity_3 = this.validateQtyMinMult(vMain[1].quantity_quantity_3, minQty, multQty);
                        // }
                        vMain[1].subTotal_quantity_1 = (vMain[1].quantity_quantity_1 * vMain[1].price_quantity_1);
                        vMain[1].subTotal_quantity_2 = vMain[1].quantity_quantity_2 ? (vMain[1].quantity_quantity_2 * vMain[1].price_quantity_2) : 0;
                        vMain[1].subTotal_quantity_3 = vMain[1].quantity_quantity_3 ? (vMain[1].quantity_quantity_3 * vMain[1].price_quantity_3) : 0;
                    });

                    this.data_to_send.line_items[slug].records = quoteLineItems;

                    if (this.data.totalRecords !== undefined) {
                        this.data_to_send.line_items[slug].count = this.data.totalRecords;
                    }
                    this.data_to_send.line_items_axios_fetch_slug = slug;
                }
            }
        } else {
            // 9075: Count is displaying 0 on different tab when quote data available
            // Neet to set it because it will be use in QuoteDetail Slice
            if (axios_params.quoteStatus &&
                quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus] !== undefined) {
                let slug = quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus].slug;
                this.data_to_send.line_items_axios_fetch_slug = slug;
            }
        }
        return this;
    };

    validateQtyMinMult = (selectedQty, qtyMin, qtyMult) => {

        if (selectedQty && selectedQty > 0) {
            if (qtyMin !== undefined && selectedQty < qtyMin) {
                return false;
            }
            if (qtyMult !== undefined && selectedQty % qtyMult !== 0) {
                return false;
            }
        }
        return true;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default quoteDetailAPICallResponseMaker;